import { RxStateComponent } from '@alliance/shared/models'
import { AfterViewInit, ChangeDetectorRef, Directive, ViewChild } from '@angular/core'
import { CarouselOptions, NgxSiemaContainerComponent } from '@alliance/shared/carousel-gallery'
import { filter, map, switchMap, take } from 'rxjs'
import { Translations } from '../localization/translations'
import { VisibilityStateService } from '../../../api'
import { CAROUSEL_OPTIONS } from '../constants/carousel'
import { CATEGORY_SLIDES_COUNT } from '../constants/categories-slides-count-map'
import { OnboardingCategoriesEnum } from '../../../domain/models/onboarding-categories.enum'
import { CategoriesDataValuesEnum } from '../models/categories-data-values.enum'

@Directive()
export class BaseOnboardingCategoryDirective
  extends RxStateComponent<{
    initialSlide: number | null
    carouselOptions: CarouselOptions
  }>
  implements AfterViewInit
{
  @ViewChild(NgxSiemaContainerComponent) public carouselRef: NgxSiemaContainerComponent | undefined
  public CategoriesDataValuesEnum = CategoriesDataValuesEnum
  public readonly state = this.connectViewState(['carouselOptions'])
  public constructor(private visibilityStateService: VisibilityStateService, public translations: Translations, private cdRef: ChangeDetectorRef) {
    super()
    this.initState({
      initialSlide: this.visibilityStateService.select('initialSlide'),
      carouselOptions: this.select('initialSlide').pipe(
        filter((v): v is number => typeof v === 'number'),
        take(1),
        switchMap(initialSlide =>
          this.visibilityStateService.select('activeCategory').pipe(
            filter((v): v is OnboardingCategoriesEnum => !!v),
            map(activeCategory => ({ ...CAROUSEL_OPTIONS, startIndex: this.getActiveSlide(initialSlide, activeCategory) }))
          )
        )
      )
    })
  }

  private getActiveSlide(activeSlide: number, category: OnboardingCategoriesEnum): number {
    const maxCount = CATEGORY_SLIDES_COUNT[category]
    return activeSlide <= maxCount - 1 ? activeSlide : 0
  }

  public backToList(): void {
    this.visibilityStateService.setActiveCategory(null)
  }

  public ngAfterViewInit(): void {
    this.cdRef.detectChanges()
    const carousel = this.carouselRef
    if (carousel) {
      this.hold(carousel.currentSlide$, () => this.cdRef.detectChanges())
    }
  }
}
